export default "__VITE_ASSET__cf2cf9bf__"